
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import {
  CandidateNewResult,
  DimensionGroupConfig,
  DimensionReportConfig
} from "@/lib/model/exam/candidate-result";

enum dimResEnum {
  "差" = 0,
  "中" = 1,
  "优" = 2
}

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: false }) dataAllReady!: boolean;

  defShow5Dim = 5; //默认显示5个维度
  groupDefShowCount = 1; //默认显示1个分组
  showMoreBtn = true; //是否显示查看全部按钮

  scoreRangeMap: {
    [key: string]: {
      scoreLimit: number[];
      levelDesc: string[];
    };
  } = {};

  showAllGroup() {
    this.groupDefShowCount = 999;
    this.showMoreBtn = false;
    this.$nextTick(() => {
      this.getStarFloat();
    });
  }

  getSvgLogo(dim: DimensionGroupConfig) {
    // @/assets/h5-dim/h5-基础能力.svg
    if (
      ["基础能力", "进阶能力", "通用素质", "岗位匹配度"].includes(dim.groupName)
    ) {
      return require(`@/assets/h5-dim/h5-${dim.groupName}.svg`);
    } else {
      return require(`@/assets/h5-dim/h5-其他维度.svg`);
    }
  }
  //这套先留着 后续可能改成使用远程svg，这套可以处理svg的颜色和大小
  // // 维度组logo
  groupLogoDefault =
    "https://oss.5kong.com/app/test/2024/08/09/5fb54f8af8dff72e21781fe2399f1894.svg";
  dimGroupLogo: { [key: string]: string } = {
    基础能力:
      "https://oss.5kong.com/app/test/2024/08/09/1e2068cbd987f58f152af259ffd1b1ab.svg",
    通用素质:
      "https://oss.5kong.com/app/test/2024/08/09/273c6e862da39b37573487eecee28f14.svg",
    岗位匹配度:
      "https://oss.5kong.com/app/test/2024/08/09/6939f97b064356007b1afe1cf1b8c3b2.svg",
    进阶能力:
      "https://oss.5kong.com/app/test/2024/08/09/8b4bfac27a47a3147d51b1a56a55cac1.svg",
    其他:
      "https://oss.5kong.com/app/test/2024/08/09/5fb54f8af8dff72e21781fe2399f1894.svg"
  };
  dimGroupLogoSvg: { [key: string]: string } = {};

  getDimGroupLogoSvg(name: string, color: string, size = 56) {
    if (!name) return "";
    const url = this.getDimGroupLogoUrl(name);
    this.getFetchSvg(url, color, size).then(res => {
      // this.dimGroupLogoSvg[name] = res as string;
      res = `${res}`;
      this.$set(this.dimGroupLogoSvg, name, res);
      console.log("this.dimGroupLogoSvg", this.dimGroupLogoSvg);
      return res;
    });
  }
  getDimGroupLogoUrl(name: string) {
    if (!name) return this.groupLogoDefault;
    return this.dimGroupLogo?.[name] || this.groupLogoDefault;
  }

  async getFetchSvg(url: string, color: string, size: number) {
    if (!url) return;
    try {
      const response = await fetch(url);
      if (response.ok) {
        const svgText = await response.text();
        const res = svgText
          .replace(/fill="[^"]*"/g, 'fill="' + color + '" fill-opacity="0.12"')
          .replace(/<svg[^>]*>/, match => {
            // 确保宽高属性被添加或替换
            if (match.includes("width") || match.includes("height")) {
              return match
                .replace(/width="[^"]*"/, 'width="' + size + 'px"')
                .replace(/height="[^"]*"/, 'height="' + size + 'px"');
            } else {
              return match.replace(
                "<svg",
                '<svg width="' + size + 'px" height="' + size + 'px"'
              );
            }
          });
        return res;
      } else {
        console.error("Failed to fetch SVG:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching SVG:", error);
    }
  }
  get examAllDimScoreTotal() {
    return this.all.report.dimensionReportList.reduce((prev, cur) => {
      return prev + cur.scoreAll;
    }, 0);
  }
  getGroupInExamPercent(dim: DimensionGroupConfig) {
    const groupScoreAll = dim.dimensionList.reduce((prev, cur) => {
      return prev + cur.scoreAll;
    }, 0);
    return ((groupScoreAll / this.examAllDimScoreTotal) * 100).toFixed(0) + "%";
  }

  @Watch("dataAllReady", { immediate: true })
  onDataReady(n: any) {
    if (n) {
      this.all.report.dimensionGroupList.forEach(item => {
        item.dimensionKeyList.forEach(key => {
          this.$set(this.scoreRangeMap, key, {
            scoreLimit: item.scoreLimit,
            levelDesc: item.levelDesc
          });
        });
      });
      this.$nextTick(() => {
        this.setEcharts(this.all.report.dimensionReportList);
      });
    }
  }
  dimResEnum = dimResEnum;

  //无级变速星星
  getStarFloat() {
    setTimeout(() => {
      this.all.report.dimensionGroupList.forEach(
        (dim: DimensionGroupConfig, index: number) => {
          const score = Number(dim.starLevel.toFixed(2)); //0 - 5  取两位小数
          const empty = 5 - Math.ceil(score); //空星星个数
          const full = Math.floor(score); //满星星个数
          const half = 5 - empty - full; //半星星个数
          const haflStar = this.$refs[
            `dim${index}star${full}left`
          ] as HTMLElement[]; //哪个是半颗星星
          if (full) {
            for (let i = 0; i < full; i++) {
              const star = this.$refs[
                `dim${index}star${i}left`
              ] as HTMLElement[];
              if (star?.[0]?.style) {
                star[0].style.width = "100%";
              }
            }
          }
          if (empty) {
            for (let i = 0; i < empty; i++) {
              const star = this.$refs[
                `dim${index}star${i + half + full}left`
              ] as HTMLElement[];
              if (star?.[0]?.style) {
                star[0].style.width = "0%";
              }
            }
          }
          if (half && haflStar?.[0]?.style) {
            haflStar[0].style.width = `${(score - full) * 100}%`; //calc(${(score - full) * 100}%)
          }
          // console.log(index, score, empty, full, score - full);
        }
      );
    }, 0);
  }

  groupLogo =
    "https://oss.hina.com/app/hina/2023/06/25/1aa4eff607c642b6c6aba3b4d16baedc.svg"; //兜底图标

  getDimensionDesc(item: {
    scoreAi: number;
    scoreAll: number;
    dimensionKey: string;
  }): string {
    if (isNaN(item.scoreAi) || isNaN(item.scoreAll)) {
      console.warn("得分数据错误");
      return "-";
    }
    const params = this.scoreRangeMap[item.dimensionKey];
    const [low, mid, high] = params.levelDesc;
    const [minNum, maxNum] = params.scoreLimit;
    const percent = Math.round((item.scoreAi / item.scoreAll) * 100);
    let judge = percent >= maxNum ? high : percent >= minNum ? mid : low;
    return judge;
  }

  newH5Type = true; //h5版样式 0711版写死true，后续会补齐
  //是否分组展示
  public get isGroup() {
    return true;
  }
  //模块展示
  public Show(p: string) {
    return true;
  }
  // 分组的 常模数据展示
  normalValueListGroup(group: DimensionGroupConfig) {
    const dList = Array.from(new Set(group.dimensionList));
    const list = dList.map((item, index) => {
      return {
        weight: `${Math.floor(item.dimensionWeight * 100)}%`,
        dimension: item.dimensionName,
        percent: item.scoreAiPercent,
        unanswered: item.unanswered,
        showMoreDimLimit: 5,
        levelDesc: group.levelDesc,
        scoreLimit: group.scoreLimit
      };
    });

    return list;
  }
  // 是否常模 (非分组时 老规则)
  get isNormalValue() {
    return this.all.report.dimensionReportList.every(
      item => item.hasNormData === 1
    );
  }
  //10 20 30 分三档时 颜色值
  getColor30(dim: DimensionGroupConfig) {
    return dim.dimensionGroupLevel === 2
      ? "#1db26f"
      : dim.dimensionGroupLevel === 1
      ? "#FF9900"
      : "#eb462d";
  }

  getColorItem30(dim: DimensionReportConfig) {
    return dim.dimensionLevel === 2
      ? "#1db26f"
      : dim.dimensionLevel === 1
      ? "#FF9900"
      : "#eb462d";
  }

  //分组 组评价
  getResTextByGroup(dim: DimensionGroupConfig) {
    let t = ``;
    t = `候选人在本次AI面试的表现为<span class='ac ac20' style='color:${this.getColor30(
      dim
    )}'>${dim.dimensionGroupLevelDesc}</span>`;
    return t;
  }

  // 维度-特判英语、普通话等
  specialJumpText(item: any) {
    if (
      item.dimension === "英语" &&
      this.all.report.englishAssessmentResult.totalLevel >= 0
    ) {
      return `候选人的英语口语水平${
        this.all.report.englishAssessmentResult.getLevel().tag
      }
			，在本次测评中综合等级${
        this.all.report.englishAssessmentResult.totalLevel
      }"/9"。
			`;
    }
    if (item.dimension === "普通话") {
      return `候选人的普通话水平${
        this.all.report.chineseAssessmentResult.levelDesc
      }
			${
        !this.Show("hiddenIseChineseScorePercent")
          ? ""
          : `，在常模人群中处于${this.all.report.chineseAssessmentResult.score}%分位。`
      }`;
    }
    return item.aiComment || "暂无评价";
  }
  specialJump(item: any) {
    if (item.dimension === "英语") {
      const english = document.querySelector(".englishCard") as HTMLElement;
      english.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    if (item.dimension === "普通话") {
      const mandarin = document.querySelector(".mandarinCard") as HTMLElement;
      mandarin.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }
  created() {
    //
  }

  setEcharts(r: DimensionReportConfig[]) {
    if (!this.dataAllReady) return;
    if (!this.$refs.ecScore) return;
    if (!this.$refs.ecWeight) return;
    if (r.length === 0) return;
    // this.scoreTotal = 0;
    // this.scoreTotalAll = 0;
    this.optionRadar.series[0].data[0].value = [];
    this.optionRadar.radar.indicator = [];
    this.optionPie.series[0].data = [];

    r.forEach((d: DimensionReportConfig, index: number) => {
      // this.scoreTotal += d.score; // 总得分
      // this.scoreTotalAll += d.scoreAll; //总分
      this.optionRadar.radar.indicator.push({
        name: d.dimensionName,
        max: d.scoreAll
      });
      //雷达数据
      this.optionRadar.series[0].data[0].value.push(
        d.scoreAi > 0 ? d.scoreAi : 0
      );
      //饼图数据
      this.optionPie.series[0].data.push({
        name: d.dimensionName,
        value: d.scoreAll
      });
    });
    if (r.length === 1) {
      this.optionPie.series[0].padAngle = 0;
    }

    //AI表格
    this.AIList = r || [];
    this.$nextTick(() => {
      //雷达
      const echartScore = echarts.init(this.$refs.ecScore as HTMLDivElement);
      echartScore.setOption(this.optionRadar);
      //饼图
      const echartsR = echarts.init(this.$refs.ecWeight as HTMLDivElement);
      echartsR.setOption(this.optionPie);
    });
  }

  //
  mounted() {
    this.getStarFloat();
    this.all.report.dimensionGroupList.forEach(item => {
      this.getDimGroupLogoSvg(item.groupName, this.getColor30(item), 56);
    });
  }
  //AI维度
  AIList: DimensionReportConfig[] = [];
  // 得分雷达图配置
  optionRadar = {
    tooltip: {},
    legend: {
      left: "right",
      top: "bottom",
      orient: "vertical", //排列方向 horizontal
      textStyle: {
        color: "#8590A6",
        fontSize: 9
      },
      itemHeight: 10,
      itemWidth: 10,
      data: ["维度得分", "维度中位分"]
    },
    radar: {
      shape: "circle",
      splitNumber: 5, //几段线
      nameGap: 5, //名称和轴的距离
      radius: "60%", //65%
      splitArea: { areaStyle: { color: ["rgba(242, 249, 255, 1)"] } }, //背景区域
      splitLine: { lineStyle: { color: ["rgba(204, 211, 240, 1)"] } }, //极坐标
      axisLine: { lineStyle: { color: "rgba(204, 211, 240, 1)" } }, //轴线
      name: {
        textStyle: {
          fontSize: "12",
          fontWeight: 400,
          fontFamily: "PingFangSC-Regular",
          color: "rgba(17, 17, 17, 1)"
        }
      },
      indicator: [
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 },
        { name: "", max: 0 }
      ]
    },
    series: [
      {
        name: "考察维度得分",
        type: "radar",
        silent: true, // 禁止交互
        symbol: "circle", //形状
        symbolSize: 2, // 拐点的大小
        itemStyle: {
          color: "rgba(255, 185, 4, 1)"
        },
        data: [
          {
            value: [0],
            name: ""
          }
        ],
        lineStyle: { color: "rgba(255, 185, 4, 1)", width: 1 },
        areaStyle: { color: "rgba(255, 185, 4, 0.50)" }
      }
    ]
  };
  //饼图用色
  colorList = [
    "#5458FF",
    "#EFA384",
    "#EF4139",
    "#FDB225",
    "#31BBF7",
    "#F8772F",
    "#19DFB0",
    "#C0EF39",
    "#9F2FF8",
    "#FDF425",
    "#39E4EF",
    "#F039A7"
  ];
  //权重饼状图配置
  optionPie = {
    tooltip: {
      trigger: "item",
      formatter: function(params: any) {
        return `${params.name}：${params.percent}%`;
      }
    },
    series: [
      {
        name: "考察维度权重",
        type: "pie",
        silent: true, // 禁止交互
        clockwise: false, //是否顺时针
        color: this.colorList,
        radius: ["35%", "60%"],
        label: {
          show: true,
          fontSize: 12,
          lineHeight: 12,
          color: "rgba(17, 17, 17, 1)",
          formatter: "{b}" + "\n" + "{d}%",
          position: "outer"
          // alignTo: "edge",
          // edgeDistance: "10%"
        },
        itemStyle: {
          borderWidth: 0,
          borderColor: "#FFFFFF"
        },
        padAngle: 1, //扇形之间的间隔
        emphasis: {
          scaleSize: 2,
          focus: "self",
          //聚焦态
          label: {
            show: true,
            fontSize: "12px",
            fontWeight: "bold"
          }
        },
        labelLine: {
          show: false,
          length: 12, //两段线 控制文字位置
          length2: 0
        },
        data: [{ value: 200, name: "A权重占比" }]
      }
    ]
  };
}
